import React, { useEffect, useState } from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";

import Header_ from "./components/Header";
import Header from "./layouts/Header";

// export default withRouter (Redirect);

const FeesPage = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  useEffect(() => {
    document.title = "Fees - Karamale";
  }, []);

  if (localStorage.getItem("customername") !== null) {
    return <Redirect to="/customerdashboard" />;
    //   return exit(1);
  } else {
  }
  return (
    <div className="view mt-5">
      <Header />
      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-10 mt-5 pl-0 pr-0">
            <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
              <div className="row align-items-center justify-content-center">
                <div className="col-12">
                  <span className="">
                    <h4 className="text-3xl font-bold text-left mb-8">
                      Karamale Fees & Pricing
                    </h4>
                  </span>
                </div>

                <div className="col-12">
                  <div className="h-divider w-100"></div>
                </div>

                <div className="col-12">
                  {/* Organiser Fees Table */}
                  <section className="mb-10">
                    <h5 className="text-2xl font-semibold mb-4">
                      Organiser Fees
                    </h5>
                    <div className="table-responsive">
                      <table className="">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-3 text-left border">Fee Type</th>
                            <th className="p-3 text-left border">Cost</th>
                            <th className="p-3 text-left border">Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-3 border">Event Creation</td>
                            <td className="p-3 border">Free</td>
                            <td className="p-3 border">
                              Create unlimited events anytime
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">Campaign Budget</td>
                            <td className="p-3 border">R10+</td>
                            <td className="p-3 border">
                              Required to activate ticket sales
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">Service Fee</td>
                            <td className="p-3 border">3.5% per ticket</td>
                            <td className="p-3 border">
                              Deducted from campaign budget only
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">
                              Self-Print (Download)
                            </td>
                            <td className="p-3 border">R1.00</td>
                            <td className="p-3 border">
                              Organiser downloads and prints tickets
                              independently
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">
                              Karamale Prints for You
                            </td>
                            <td className="p-3 border">R3.50</td>
                            <td className="p-3 border">
                              Karamale handles ticket printing and delivery
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">Payout Fee</td>
                            <td className="p-3 border">Small fee</td>
                            <td className="p-3 border">
                              Visible in your Payouts dashboard
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <p className="mt-4 text-sm italic">
                      <strong>Note:</strong> Ticket revenue is 100% yours —
                      Karamale never takes a cut. A small payout fee applies
                      when funds are transferred to your account.
                    </p>
                  </section>

                  <section>
                    <h5 className="text-2xl font-bold mb-10 mt-4">
                      Ticket Format Costs to Organiser
                    </h5>
                    <div className="table-responsive">
                      <table className="">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-3 text-left border">
                              Ticket Format
                            </th>
                            <th className="p-3 text-left border">Method</th>
                            <th className="p-3 text-left border">
                              Organiser Cost
                            </th>
                            <th className="p-3 text-left border">Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="p-3 border">Digital Ticket</td>
                            <td className="p-3 border">
                              Issued electronically
                            </td>
                            <td className="p-3 border">
                              3.5% (from campaign budget)
                            </td>
                            <td className="p-3 border">
                              Automatically deducted when ticket is sold
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">Physical Ticket</td>
                            <td className="p-3 border">
                              Download + Self-Print
                            </td>
                            <td className="p-3 border">R1.00 per ticket</td>
                            <td className="p-3 border">
                              Fixed cost when organiser downloads a ticket to
                              print manually. Amount also deducted from the
                              budget
                            </td>
                          </tr>
                          <tr>
                            <td className="p-3 border">Physical Ticket</td>
                            <td className="p-3 border">Printed by Karamale</td>
                            <td className="p-3 border">R3.50 per ticket</td>
                            <td className="p-3 border">
                              Karamale prints and prepares the ticket for
                              distribution
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <p className="mt-4 text-sm italic text-gray-700">
                      🛡️ All ticket formats include full fraud protection and
                      scanning validation.
                    </p>
                  </section>

                  {/* Buyer Fees Section */}
                  <section className="mb-10 mt-4">
                    <h5 className="text-2xl font-semibold mb-4">Buyer Fees</h5>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Small booking fee added at checkout</li>
                      <li>No extra charges for payment processing</li>
                      <li>All fees are clearly displayed to buyers upfront</li>
                    </ul>
                  </section>

                  {/* Campaign Model Explanation */}
                  <section className="mb-10">
                    <h5 className="text-2xl font-semibold mb-4">
                      Campaign Model
                    </h5>
                    <p>
                      Karamale operates on a campaign-based system. You create a
                      free event, then activate it by launching a campaign with
                      a budget of your choice. Every ticket sale deducts 3.5%
                      from your budget — never from your earnings.
                    </p>
                    <p className="mt-2">
                      If your budget runs out, your event is paused until you
                      top up. Any leftover budget rolls into your next event —
                      no refunds, but no waste.
                    </p>
                  </section>

                  {/* Promoter Accounts Section */}
                  <section className="mb-10">
                    <h5 className="text-2xl font-semibold mb-4">
                      Promoter Accounts
                    </h5>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Create unique login credentials for each promoter</li>
                      <li>
                        Promoters can sell tickets directly on your behalf
                      </li>
                      <li>
                        Track ticket sales, earnings, and category-level
                        breakdowns
                      </li>
                      <li>
                        Deactivate or permanently delete promoters based on
                        performance
                      </li>
                    </ul>
                  </section>

                  {/* FAQs */}
                  <section>
                    <h5 className="text-2xl font-semibold mb-4">❓ FAQs</h5>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>
                        <strong>Is it free to create events?</strong> → Yes,
                        completely free.
                      </li>
                      <li>
                        <strong>
                          What happens when my campaign budget runs out?
                        </strong>{" "}
                        → Your event pauses until you add more funds.
                      </li>
                      <li>
                        <strong>Can I sell printed tickets only?</strong> → Yes,
                        both printed and digital tickets are fully validated.
                      </li>
                      <li>
                        <strong>Is there a minimum campaign budget?</strong> →
                        You can start with just R10.00.
                      </li>
                    </ul>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

const Collapsible = ({ title, children, isOpen, toggle }) => (
  <div className="mb-6">
    <button
      onClick={toggle}
      className="w-full text-left bg-gray-200 px-4 py-3 rounded-md font-semibold hover:bg-gray-300 transition"
    >
      {title} {isOpen ? "🔽" : "▶️"}
    </button>
    {isOpen && <div className="mt-2">{children}</div>}
  </div>
);

export default FeesPage;
